import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Table, Descriptions, Pagination, message } from 'antd';
import axios from 'axios';
import { baseUrl } from '../../config/apiConfig';
import moment from 'moment';

const SettlementDetail = () => {
  const { id } = useParams();
  const [items, setItems] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSettlementItems(pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize]);

  const fetchSettlementItems = async (pageNum, pageSize) => {
    setLoading(true);
    try {
      const response = await axios.post(`${baseUrl}/settlement/select_settlement_item_page`, {
        pageNum,
        pageSize,
        settlementId: id,
      });
      const { code, msg, data } = response.data;
      if (code === 200) {
        console.log("select_settlement_item_page", data);
        setItems(data.list);
        setPagination({
          current: data.pageNum,
          pageSize: data.pageSize,
          total: data.total,
        });
      } else {
        message.error(msg || 'data loading failed');
      }
    } catch (error) {
      message.error('request failed');
    }
    setLoading(false);
  };

  const columns = [
    { title: 'Type', dataIndex: 'type', key: 'type' },
    { title: 'Pay ID', dataIndex: 'payId', key: 'payId' },
    { title: 'Refund ID', dataIndex: 'refundId', key: 'refundId', render: (text) => text || '-' },
    { title: 'Amount', dataIndex: 'amount', key: 'amount', render: (text) => `${(text / 100).toFixed(2)}` },
    { title: 'Service Fee', dataIndex: 'serviceAmount', key: 'serviceAmount', render: (text) => `${(text / 100).toFixed(2)}` },
    { title: 'Order Amount', dataIndex: 'orderAmount', key: 'orderAmount', render: (text) => `${(text / 100).toFixed(2)}` },
    { title: 'Create Time', dataIndex: 'createTime', key: 'createTime', render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss') },
    { title: 'Status', dataIndex: 'status', key: 'status' },
  ];

  const handleTableChange = (pagination) => {
    fetchSettlementItems(pagination.current, pagination.pageSize);
  };

  return (
    <div>
      <Descriptions title="Settlement Detail" bordered>
        <Descriptions.Item label="Settlement ID">{id}</Descriptions.Item>
      </Descriptions>

      <Table
        columns={columns}
        dataSource={items}
        rowKey="id"
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        style={{ marginTop: '20px' }}
      />
    </div>
  );
};

export default SettlementDetail;
